/**
 * The mark above the empty composer.
 *
 * A conversation with nothing in it is a blank screen, and a blank screen reads
 * as broken rather than as ready. This gives the empty state something alive to
 * anchor on, without pretending to be content.
 *
 * A dot grid instead of a logo because it is the same vocabulary the rest of the
 * page already speaks — the aurora, the breathing status dot, the typing dots.
 * Each column breathes on its own offset so the field never pulses in unison,
 * which is what would make it look like a loading indicator.
 *
 * Purely decorative, so it is hidden from assistive tech and stops entirely
 * under `prefers-reduced-motion`.
 */

const COLUMNS = 4;
const ROWS = 5;
const DOTS = 6;

/** Alguns pontos ganham cor de acento — o suficiente para não parecer ruído. */
const ACCENTS = {
  "0-2": "#40dea8",
  "1-4": "#ff9ecd",
  "2-1": "#7b9bff",
  "2-3": "#40dea8",
  "3-0": "#8b8bff",
  "3-4": "#ff5a4d",
};

export default function LucasSpark() {
  return (
    <div aria-hidden="true" className="flex items-end justify-center gap-3">
      {Array.from({ length: COLUMNS }, (_, column) => (
        <div
          key={column}
          className="animate-breathe motion-reduce:animate-none"
          style={{ animationDelay: `${column * 0.34}s`, animationDuration: "3.6s" }}
        >
          {Array.from({ length: ROWS }, (_, row) => (
            <div key={row} className="flex gap-[5px] pb-[5px]">
              {Array.from({ length: DOTS }, (_, dot) => {
                const accent = ACCENTS[`${column}-${row}`];
                return (
                  <span
                    key={dot}
                    className="h-[5px] w-[5px] rounded-full bg-black/[.13] dark:bg-white/[.16]"
                    style={
                      accent && dot === (column + row) % DOTS
                        ? { background: accent }
                        : undefined
                    }
                  />
                );
              })}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
